import React, { FunctionComponent } from "react";
import {
  Breadcrumb,
  IBreadcrumbItem,
} from "office-ui-fabric-react/lib/Breadcrumb";

export const Breadcrumbs: FunctionComponent<{ steps: IBreadcrumbItem[] }> = ({
  steps,
}) => {
  return (
    <Breadcrumb
      items={steps}
      maxDisplayedItems={2}
      ariaLabel="Breadcrumb with items rendered as buttons"
      overflowAriaLabel="More links"
    />
  );
};
